import React, { useState, useEffect } from "react";
import { Table, Badge, Modal, ListGroup } from 'react-bootstrap';
import { geo_busca_populacao } from "../../services/api";

const Geo_lista_populacao = ({ unidade, range, onDataProcessed }) => {
    // Estados principais
    const [dadosPopulacao, setDadosPopulacao] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: 'bairro', direction: 'asc' });

    // Estados do Modal
    const [showModal, setShowModal] = useState(false);
    const [bairroSelecionado, setBairroSelecionado] = useState(null);

    // Mapeamento direto das chaves do JSON para o nome das unidades
    const mapaUnidades = {
        alunos_br: "Bento Ribeiro",
        alunos_md: "Madureira",
        alunos_sc: "Santa Cruz",
        alunos_cd: "Cascadura",
        alunos_tq: "Taquara",
        alunos_np: "Nilópolis",
        alunos_sp: "Seropédica",
        alunos_bt: "Barra",
        alunos_cg: "Campo Grande",
        alunos_mg: "Mangueira",
        alunos_mc: "Maricá",
        alunos_ig: "Ilha",
        alunos_fg: "Freguesia",
        alunos_rb: "Recreio"
    };

    const formatarMoeda = (valor) => {
        if (!valor) return "R$ 0,00";
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(parseFloat(valor));
    };

    const fetchData = async () => {
        try {
            const response = await geo_busca_populacao(unidade, range);
            const listaSaneada = Array.isArray(response) ? response : (response?.data || []);

            // Adiciona a propriedade calculada de total jovem por bairro
            const dadosComTotal = listaSaneada.map(item => ({
                ...item,
                total_bairro: (
                    parseInt(item.pop_0_a_4_anos || 0) +
                    parseInt(item.pop_5_a_9_anos || 0) +
                    parseInt(item.pop_10_a_14_anos || 0) +
                    parseInt(item.pop_15_a_19_anos || 0)
                )
            }));

            setDadosPopulacao(dadosComTotal);

            if (onDataProcessed) {
                const totalJovem = dadosComTotal.reduce((acc, curr) => acc + curr.total_bairro, 0);
                onDataProcessed({
                    bairros: dadosComTotal.length,
                    totalJovem: totalJovem
                });
            }

        } catch (error) {
            console.error("Erro ao buscar dados de população por range:", error);
            setDadosPopulacao([]);

            if (onDataProcessed) {
                onDataProcessed({ bairros: 0, totalJovem: 0 });
            }
        }
    };

    useEffect(() => {
        if (unidade && range) {
            fetchData();
        }
    }, [unidade, range]);

    // Função de Ordenação
    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const sortedData = [...dadosPopulacao].sort((a, b) => {
        let valA = a[sortConfig.key];
        let valB = b[sortConfig.key];

        if (typeof valA === 'string' && typeof valB === 'string' && isNaN(valA)) {
            valA = valA.toUpperCase();
            valB = valB.toUpperCase();
        } else {
            valA = parseFloat(valA || 0);
            valB = parseFloat(valB || 0);
        }

        if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
        if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
    });

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) return " ↕";
        return sortConfig.direction === 'asc' ? " 🔼" : " 🔽";
    };

    // Handlers do Modal
    const abrirModal = (bairroInfo) => {
        setBairroSelecionado(bairroInfo);
        setShowModal(true);
    };

    const fecharModal = () => {
        setShowModal(false);
        setBairroSelecionado(null);
    };

    return (
        <>
            <div className="table-responsive" style={{ maxHeight: '60vh' }}>
                <Table striped bordered hover size="sm" className="align-middle bg-white m-0">
                    <thead className="table-dark text-center sticky-top">
                        <tr style={{ fontSize: '11px', cursor: 'pointer' }}>
                            <th onClick={() => requestSort('bairro')} className="align-middle text-start ps-3" style={{ minWidth: '150px' }}>
                                BAIRRO {getSortIcon('bairro')}
                            </th>
                            <th onClick={() => requestSort('pop_0_a_4_anos')} className="align-middle">
                                0-4 {getSortIcon('pop_0_a_4_anos')}
                            </th>
                            <th onClick={() => requestSort('pop_5_a_9_anos')} className="align-middle">
                                5-9 {getSortIcon('pop_5_a_9_anos')}
                            </th>
                            <th onClick={() => requestSort('pop_10_a_14_anos')} className="align-middle">
                                10-14 {getSortIcon('pop_10_a_14_anos')}
                            </th>
                            <th onClick={() => requestSort('pop_15_a_19_anos')} className="align-middle">
                                15-19 {getSortIcon('pop_15_a_19_anos')}
                            </th>
                            <th onClick={() => requestSort('total_bairro')} className="align-middle bg-success text-white border-success">
                                TOTAL JOVENS {getSortIcon('total_bairro')}
                            </th>
                            <th onClick={() => requestSort('valor_mediano')} className="align-middle text-nowrap">
                                RENDA MEDIANA {getSortIcon('valor_mediano')}
                            </th>
                            <th onClick={() => requestSort('valor_medio')} className="align-middle text-nowrap">
                                RENDA MÉDIA {getSortIcon('valor_medio')}
                            </th>
                            <th onClick={() => requestSort('total_alunos')} className="align-middle bg-primary text-white border-primary">
                                ALUNOS SM {getSortIcon('total_alunos')}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedData.length > 0 ? (
                            sortedData.map((item, index) => (
                                <tr key={index} className="text-center">
                                    <td className="text-start fw-bold small ps-3">{item.bairro}</td>
                                    <td className="small">{item.pop_0_a_4_anos}</td>
                                    <td className="small">{item.pop_5_a_9_anos}</td>
                                    <td className="small">{item.pop_10_a_14_anos}</td>
                                    <td className="small">{item.pop_15_a_19_anos}</td>
                                    <td>
                                        <Badge bg="success" className="w-100">
                                            {item.total_bairro}
                                        </Badge>
                                    </td>
                                    <td className="small text-nowrap">{formatarMoeda(item.valor_mediano)}</td>
                                    <td className="small text-nowrap">{formatarMoeda(item.valor_medio)}</td>
                                    <td>
                                        <Badge
                                            bg={parseInt(item.total_alunos) > 0 ? "primary" : "secondary"}
                                            className="w-100"
                                            style={{ cursor: parseInt(item.total_alunos) > 0 ? 'pointer' : 'default' }}
                                            onClick={() => parseInt(item.total_alunos) > 0 && abrirModal(item)}
                                        >
                                            {item.total_alunos || 0}
                                        </Badge>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" className="text-center py-4 text-muted">
                                    Nenhum dado populacional retornado para os parâmetros informados.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            {/* Modal de Detalhamento dos Alunos */}
            <Modal show={showModal} onHide={fecharModal} centered size="sm">
                <Modal.Header closeButton className="bg-primary text-white">
                    <Modal.Title className="h6 mb-0">
                        Alunos em {bairroSelecionado?.bairro}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <ListGroup variant="flush">
                        {bairroSelecionado && Object.entries(mapaUnidades).map(([chave, nomeUnidade]) => {
                            const quantidade = parseInt(bairroSelecionado[chave] || 0);
                            // Renderiza apenas se houver alunos daquela unidade no bairro
                            if (quantidade > 0) {
                                return (
                                    <ListGroup.Item key={chave} className="d-flex justify-content-between align-items-center">
                                        <span className="small fw-semibold">{nomeUnidade}</span>
                                        <Badge bg="primary" pill>
                                            {quantidade}
                                        </Badge>
                                    </ListGroup.Item>
                                );
                            }
                            return null;
                        })}
                    </ListGroup>
                </Modal.Body>
                <Modal.Footer className="p-1">
                    <div className="w-100 text-center text-muted small">
                        Total da Rede: <strong>{bairroSelecionado?.total_alunos}</strong>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Geo_lista_populacao;